import { render, staticRenderFns } from "./Streamer-tencent.vue?vue&type=template&id=559d02a5&scoped=true"
import script from "./Streamer-tencent.vue?vue&type=script&lang=js"
export * from "./Streamer-tencent.vue?vue&type=script&lang=js"
import style0 from "./Streamer-tencent.vue?vue&type=style&index=0&id=559d02a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559d02a5",
  null
  
)

export default component.exports